import styled from 'styled-components';

export const ModalTitle = styled.h1`
  letter-spacing: 1.7px;
  font-size: 3.4rem;
  text-transform: uppercase;
  margin-bottom: 3.3rem;
`;

export const ModalButton = styled.button`
  width: 487px;
  height: 58px;
  background: transparent linear-gradient(96deg, #000000 0%, #232323 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50px;

  color: #fff;
  font-size: 2.4rem;
  font-weight: bold;

  @media (max-width: 425px) {
    width: 80%;
  }
`;

export const Header = styled.header`
  min-height: 10.6rem;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 3.1rem;
`;

export const HeaderWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

export const HeaderLabel = styled.span`
  font-size: 2.5rem;
  color: #ffdf22;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.25px;
  margin-left: 0.6rem;
`;

export const Container = styled.div`
  width: 100%;
  overflow-y: auto;
`;

export const PageHeader = styled.header`
  align-items: center;
  justify-content: space-between;

  padding: 3.6rem 6rem 2.8rem 6rem;

  > button {
    max-width: none;
    margin-bottom: 1rem;
  }

  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

export const ContentRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  width: 100%;
  height: 5rem;

  @media (min-width: 475px) {
    display: flex;
  }

  /* @media (max-width: 1024px) {
    justify-content: center;
  } */
`;

export const InputContainer = styled.div`
  background: #fff;

  width: 100%;

  height: 5rem;
  border-radius: 8rem;

  @media (min-width: 475px) {
    display: flex;
  }

  @media (min-width: 768px) {
    max-width: 42rem;
  }

  form {
    background: #fff;
    width: 100%;
    height: 5rem;
    border-radius: 8rem;
    flex: 1;

    display: flex;
    align-items: center;
    height: 100%;

    svg {
      &:first-child {
        margin-left: 2.5rem;
        margin-right: 0.8rem;
      }

      &:last-child {
        width: 4rem;
        height: auto;

        margin-right: 3rem;
        cursor: pointer;

        border-radius: 50%;

        transition: 180ms ease-in;

        :hover {
          background: #d3d3d3;
        }
      }
    }

    input {
      width: 100%;
      height: 100%;
      border: 0;

      font-size: 1.7rem;
      letter-spacing: 0.85px;
      line-height: 2.1rem;
      color: #000;

      &::placeholder {
        color: #000000;
      }
    }
  }
`;

export const CardContainer = styled.ul`
  margin: 3rem 3.1rem;
  padding-bottom: 3rem;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3rem;

  @media (max-width: 1440px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    margin: 0 2rem;
  }
`;

type CheckButtonProps = {
  isSelected?: boolean;
};

export const CheckButton = styled.button.attrs({
  type: 'button',
})<CheckButtonProps>`
  margin-bottom: 0.7rem;
  background: transparent;

  display: flex;

  align-items: center;

  .radio {
    width: 2.7rem;
    height: 2.7rem;
    background: #fff;

    border: 1px solid #000;
    border-radius: 0.4rem;
  }

  .filled {
    width: 100%;
    height: 100%;
    border: 2px solid #fff;
    border-radius: 0.4rem;

    background: ${({ isSelected }) => (isSelected ? '#000' : false)};
  }

  p {
    color: #000;

    font-size: 1.8rem;
    padding: 0 1.5rem;
    text-transform: capitalize;
  }

  :active {
    filter: opacity(0.5);
  }
`;

export const CheckboxWrapper = styled.div`
  span {
    font-weight: bold;
    font-size: 1.8rem;
    margin-left: 1.6rem;
  }

  .set {
    margin-top: 0.7rem;
    width: 44.5rem;
    height: 33.8rem;
    border: 1px solid #00000020;
    border-radius: 0.8rem;

    padding: 1rem 2.4rem;
    overflow: auto;

    margin-bottom: 6.1rem;

    ::-webkit-scrollbar {
      width: 9px;
    }

    ::-webkit-scrollbar-track {
      background: #e9e9e9;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #000;
      border-radius: 20px;
      border: 2px solid #e9e9e9;
    }

    @media (max-width: 425px) {
      width: 100%;
    }
  }

  @media (max-width: 425px) {
    width: 80%;
  }
`;

export const CheckboxSet = styled.fieldset`
  border: none;
  padding-left: 0.5rem;

  display: flex;
  flex-direction: column;
  margin-bottom: 0.7rem;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;

  flex: 1;

  > h1 {
    color: #ffdf22;
  }
`;
